import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
// import moment from 'moment'
// import 'swiper/dist/css/swiper.css'
// 引入自定义弹窗组件
// import Modal from './util/Modal'
// 引入自定义Toast组件
// import Toast from './util/Toast'
// 引入jsMsg
// import MSG from './util/Msg'
// 引入API
// import ports from './api/ports'
// 引入API
// import XHR from './util/Xhr'
// 引入Log
// import log from './util/Log'
// 引入粘贴板
// import clipboard from 'clipboard'
// 引入JavascriptToClient
import JavascriptToClient from './util/JavascriptToClient'
// 引入Storage
// import Storage from './util/Storage'
// 引入Statistics
// import Statistics from './util/Statistics'
import {
  LocaleProvider,
  message,
  Switch,
  modal,
  Pagination,
  form,
  input,
  select,
  DatePicker,
  TimePicker,
  Checkbox,
  Button,
  Radio
} from 'ant-design-vue'
// 引入Pid
// import Pid from './util/Pid'
// 引入Cef
import Cef from './util/Cef'

// 引入DB
// import db from './util/Db'

// 引入animated
// import animated from 'animate.css'
// 引入MD5
// import md5 from 'js-md5'

// Vue.component(Switch.name, Switch)

Vue.config.productionTip = false

// 注册到vue原型上
// Vue.prototype.Clipboard = clipboard
// Vue.prototype.ports = ports
// Vue.prototype.MSG = MSG
// Vue.prototype.DSP = Statistics
// Vue.prototype.moment = moment
// Vue.prototype.PID = Pid
Vue.prototype.CEF = Cef

// Vue.prototype.$message = message
// Vue.prototype.$confirm = modal.confirm

// Vue.prototype.db = db // 全局挂在操作db

// Vue.prototype.$md5 = md5

// Vue.use(modal)
// Vue.use(Pagination)
// Vue.use(form)
// Vue.use(input)
// Vue.use(select)
// Vue.use(DatePicker)
// Vue.use(TimePicker)
// Vue.use(Checkbox)
// Vue.use(Button)
// Vue.use(Modal)
// Vue.use(Radio)
// Vue.use(LocaleProvider)
// Vue.use(Storage)
// Vue.use(Toast)
// Vue.use(XHR)
// Vue.use(VueAxios, axios)
// Vue.use(store)
Vue.use(JavascriptToClient)
// Vue.use(log)
Vue.use(VueCookies)
// Vue.use(animated)

// 判断是否有游戏窗口
// Vue.prototype.hasGameWnd = (type, fn) => {
//   this.Storage.get('hasGameWnd', res => {
//     let hasWnd = res.data.hasGameWnd
//     if (type === 1) {
//       hasWnd = hasWnd ? hasWnd + 1 : 1
//     } else if (type === 0) {
//       hasWnd = hasWnd ? hasWnd - 1 : 0
//     }
//     res.data.hasGameWnd = hasWnd
//     this.Storage.set('hasGameWnd', hasWnd)
//     fn && fn(res)
//   })
// }

window.myapp = new Vue({
  router,
  store,
  render: h => h(App),
  async created() {
    // 创建数据库
    // await this.db.createOrOpenDb('vueDB', 1)
    // 创建对象结构
    // await this.db.createObjectStore('clock', {
    //   keyPath: 'id',
    //   id: true
    // })
    // 创建对象结构所属的方法
    // await this.db.createObjectStoreOperations('clock')
  }
}).$mount('#app')
